import React from 'react';

import { DEFAULT_EMPTY, DEFAULT_LOCALE, DEFAULT_TEMPLATE } from './constants';
import { IDateFormatterContext, IDateFormatterProvider } from './interfaces';

const DateFormatterContext = React.createContext<IDateFormatterContext>({
  locale: DEFAULT_LOCALE,
  template: DEFAULT_TEMPLATE,
  empty: DEFAULT_EMPTY,
});

export const DateFormatterProvider = ({
  children,
  locale = DEFAULT_LOCALE,
  template = DEFAULT_TEMPLATE,
  empty = DEFAULT_EMPTY,
}: IDateFormatterProvider) => {
  return (
    <DateFormatterContext.Provider value={{ locale, template, empty }}>
      {children}
    </DateFormatterContext.Provider>
  );
};

export default DateFormatterContext;
